export default {"src":"/_next/static/media/cryptopedia_social_website.5ae8eba9.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};